import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SuspenseLoader } from 'components';

const Groups = React.lazy(() => import('./groups-list'));
const GroupSummary = React.lazy(() => import('./group-summary'));
const EditGroup = React.lazy(() => import('./edit-group'));

const GroupsBase = () => (
  <React.Suspense fallback={<SuspenseLoader />}>
    <Routes>
      <Route path="/" element={<Groups />} />
      <Route path="/summary/:id" element={<GroupSummary />} />
      <Route path="/edit/:id" element={<EditGroup />} />
    </Routes>
  </React.Suspense>
);

export default GroupsBase;
